import React, { useState, useEffect } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { blue, orange, red } from '@mui/material/colors';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';

import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Brightness2Icon from '@mui/icons-material/Brightness2';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import NumbersIcon from '@mui/icons-material/Numbers';

import SystemDetails from './components/SystemDetails';
import DoubleChart from './components/DoubleChart';
import './App.css';

function App() {
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [darkMode, setDarkMode] = useState(true);
	const [extraDetails, setExtraDetails] = useState(false);
	const [theme, setTheme] = useState(updateTheme(true));

	function handleDrawerOpen() {
		setDrawerOpen(true);
	}

	function handleDrawerClose() {
		setDrawerOpen(false);
	}

	function updateTheme(mode) {
		return createTheme({
			palette: {
				mode: mode ? 'dark' : 'light',
				primary: {
					main: mode ? blue[600] : blue[900]
				},
				secondary: {
					main: mode ? orange[600] : orange[900]
				},
				red: {
					main: mode ? red[600] : red[900]
				}
			}
		});
	}

	useEffect(() => {
		const dark = localStorage.getItem('darkMode') === 'false' ? false : true;
		setDarkMode(dark);
		setTheme(updateTheme(dark));
	}, []);

	useEffect(() => {
		localStorage.setItem('darkMode', darkMode);
		setTheme(updateTheme(darkMode));
	}, [darkMode]);

	useEffect(() => {
		const details = localStorage.getItem('extraDetails') === 'false' ? false : true;
		setExtraDetails(details);
	}, []);

	useEffect(() => {
		localStorage.setItem('extraDetails', extraDetails);
	}, [extraDetails]);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<AppBar position="static">
				<Toolbar>
					<IconButton size="large" edge="start" aria-label="menu" color="inherit" sx={{ mr: 2 }} onClick={handleDrawerOpen}>
						<MenuIcon />
					</IconButton>
					<Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
						SolarEdge
					</Typography>
				</Toolbar>
			</AppBar>
			<Box
				sx={{
					overflow: 'auto',
					flexGrow: 0,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'flex-start',
					flexWrap: 'wrap',
					padding: 1
				}}
			>
				<SystemDetails extraDetails={extraDetails} />
				<DoubleChart day1={{ label: 'Ma', time: 'today' }} day2={{ label: 'Tegnap', time: 'yesterday' }} value="acp" unit="W" beginAtZero={true} />
			</Box>
			<Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
				<List>
					<ListItem button onClick={handleDrawerClose}>
						<ListItemIcon>
							<ArrowBackIosIcon />
						</ListItemIcon>
						<ListItemText primary="Bezárás" />
					</ListItem>
				</List>
				<Divider />
				<List>
					<ListItem
						button
						onClick={() => {
							setDarkMode((mode) => !mode);
							handleDrawerClose();
						}}
					>
						<ListItemIcon>{darkMode ? <Brightness7Icon /> : <Brightness2Icon />}</ListItemIcon>
						<ListItemText primary={darkMode ? 'Világos mód' : 'Sötét mód'} />
					</ListItem>
					<ListItem
						button
						onClick={() => {
							setExtraDetails((details) => !details);
							handleDrawerClose();
						}}
					>
						<ListItemIcon>
							<NumbersIcon />
						</ListItemIcon>
						<ListItemText primary={!extraDetails ? 'Részletek mutatása' : 'Részletek elrejtése'} />
					</ListItem>
				</List>
			</Drawer>
		</ThemeProvider>
	);
}

export default App;
